<template>
  <div class="app-container">
    <!-- 状态选项卡 -->
    <el-tabs v-model="activeStatus" @tab-click="handleTabClick">
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="待服务" name="pending"></el-tab-pane>
      <el-tab-pane label="服务中" name="serving"></el-tab-pane>
      <el-tab-pane label="已服务" name="completed"></el-tab-pane>
      <el-tab-pane label="已取消" name="cancelled"></el-tab-pane>
    </el-tabs>

    <!-- 统计栏 -->
    <div class="summary-bar">
      <div class="summary-item">
        <div class="label">下单次数</div>
        <div class="value">{{ stats.orderCount }}</div>
      </div>
      <div class="summary-item">
        <div class="label">完成次数</div>
        <div class="value" style="color: #67C23A">{{ stats.completedCount }}</div>
      </div>
      <div class="summary-item">
        <div class="label">取消次数</div>
        <div class="value" style="color: #909399">{{ stats.cancelledCount }}</div>
      </div>
      <div class="summary-item">
        <div class="label">回收金额(元)</div>
        <div class="value" style="color: #E6A23C">{{ stats.recyclingAmount }}</div>
      </div>
    </div>

    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-form :inline="true" :model="searchParams" size="small">
        <el-form-item>
          <el-input v-model="searchParams.user_id" placeholder="用户编号" clearable style="width: 140px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchParams.phone" placeholder="用户手机号" clearable style="width: 140px;"></el-input>
        </el-form-item>
        
        <!-- 区域选择 -->
        <el-form-item>
          <el-select v-model="searchParams.province_code" placeholder="选择省" clearable style="width: 120px;" @change="onProvinceSelect">
            <el-option v-for="p in provinces" :key="p.code" :label="p.name" :value="p.code" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.city_code" placeholder="选择市" clearable style="width: 120px;" @change="onCitySelect">
            <el-option v-for="c in cities" :key="c.code" :label="c.name" :value="c.code" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.area_code" placeholder="选择区" clearable style="width: 120px;" @change="onAreaSelect">
            <el-option v-for="a in areas" :key="a.code" :label="a.name" :value="a.code" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.street_code" placeholder="选择街道" clearable style="width: 120px;">
            <el-option v-for="s in streets" :key="s.code" :label="s.name" :value="s.code" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-date-picker
            v-model="searchParams.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <div class="data-table">
      <el-table :data="tableData" v-loading="loading" border style="width: 100%">
        <el-table-column prop="user_id" label="用户编号" width="100" align="center"></el-table-column>
        <el-table-column prop="user_phone" label="用户手机号" width="120" align="center"></el-table-column>
        <el-table-column prop="address" label="下单地址" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="下单时间" width="160" align="center">
          <template slot-scope="scope">
            {{ getOrderTime(scope.row) || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="service_person_name" label="服务人员" width="100" align="center"></el-table-column>
        <el-table-column prop="service_person_phone" label="服务人员手机号" width="120" align="center"></el-table-column>
         <el-table-column label="服务时间" width="160" align="center">
          <template slot-scope="scope">
            {{ getServiceTime(scope.row) || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="回收物品图片" width="120" align="center">
          <template slot-scope="scope">
            <el-image 
              style="width: 50px; height: 50px"
              :src="scope.row.image_url" 
              :preview-src-list="[scope.row.image_url]"
              v-if="scope.row.image_url">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="回收重量(kg)" width="120" align="center"></el-table-column>
        <el-table-column prop="amount" label="回收金额(元)" width="120" align="center"></el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">{{ getStatusLabel(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDetail(scope.row)">查看详情</el-button>
            <el-button type="text" size="small" @click="handleTransfer(scope.row)" v-if="scope.row.status === 'pending'">转交订单</el-button>
            <el-button type="text" size="small" style="color: #F56C6C" @click="handleCancel(scope.row)" v-if="['pending', 'serving'].includes(scope.row.status)">取消订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/api/interceptor'
import { getOrders, getStats, transferOrder, cancelOrder } from '@/api/doorRecycling'

export default {
  name: 'DoorRecycling',
  data() {
    return {
      activeStatus: 'all',
      loading: false,
      stats: {
        orderCount: 0,
        completedCount: 0,
        cancelledCount: 0,
        recyclingAmount: 0.00
      },
      searchParams: {
        user_id: '',
        phone: '',
        province_code: '',
        city_code: '',
        area_code: '',
        street_code: '',
        dateRange: []
      },
      provinces: [],
      cities: [],
      areas: [],
      streets: [],
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.fetchProvinces()
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          page_size: this.pagination.pageSize,
          status: this.activeStatus === 'all' ? '' : this.activeStatus,
          user_id: this.searchParams.user_id,
          phone: this.searchParams.phone,
          province_code: this.searchParams.province_code,
          city_code: this.searchParams.city_code,
          area_code: this.searchParams.area_code,
          street_code: this.searchParams.street_code,
        }
        
        if (this.searchParams.dateRange && this.searchParams.dateRange.length === 2) {
          params.start_time = this.searchParams.dateRange[0]
          params.end_time = this.searchParams.dateRange[1]
        }

        const [ordersRes, statsRes] = await Promise.all([
          getOrders(params),
          getStats(params)
        ])

        if (ordersRes && ordersRes.code === 0) {
          this.tableData = ordersRes.data.list || []
          this.pagination.total = ordersRes.data.total || 0
        } else {
          this.tableData = []
          this.pagination.total = 0
        }

        if (statsRes && statsRes.code === 0) {
          this.stats = {
            orderCount: statsRes.data.order_count || 0,
            completedCount: statsRes.data.completed_count || 0,
            cancelledCount: statsRes.data.cancelled_count || 0,
            recyclingAmount: statsRes.data.recycling_amount || 0
          }
        }
      } catch (e) {
        console.error('Fetch data error:', e)
        this.tableData = []
      } finally {
        this.loading = false
      }
    },
    
    // Region helpers (copied logic)
    async fetchProvinces() {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get' })
        const body = res && res.data ? res.data : res
        this.provinces = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
      } catch (e) { this.provinces = [] }
    },
    async fetchCities(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        this.cities = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
      } catch (e) { this.cities = [] }
    },
    async fetchAreas(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        this.areas = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
      } catch (e) { this.areas = [] }
    },
    async fetchStreets(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        this.streets = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
      } catch (e) { this.streets = [] }
    },
    
    onProvinceSelect(code) {
      this.searchParams.city_code = ''
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.cities = []
      this.areas = []
      this.streets = []
      if (code) this.fetchCities(code)
    },
    onCitySelect(code) {
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.areas = []
      this.streets = []
      if (code) this.fetchAreas(code)
    },
    onAreaSelect(code) {
      this.searchParams.street_code = ''
      this.streets = []
      if (code) this.fetchStreets(code)
    },

    handleTabClick() {
      this.pagination.page = 1
      this.fetchData()
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchData()
    },
    handleReset() {
      this.searchParams = {
        user_id: '',
        phone: '',
        province_code: '',
        city_code: '',
        area_code: '',
        street_code: '',
        dateRange: []
      }
      this.cities = []
      this.areas = []
      this.streets = []
      this.fetchData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchData()
    },
    
    // Operations
    handleDetail(row) {
      // 实际项目中可能跳转到详情页或弹窗显示更多信息
      // 这里先简单展示
      this.$alert(`查看订单详情: ${row.id}`, '详情', { confirmButtonText: '确定' })
    },
    handleTransfer(row) {
      this.$prompt(`请输入转交说明 (订单号: ${row.id})`, '转交订单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        try {
          await transferOrder(row.id, { reason: value })
          this.$message.success('转交成功')
          this.fetchData()
        } catch (e) {
          // error handled by interceptor
        }
      }).catch(() => {})
    },
    handleCancel(row) {
      this.$confirm(`确认取消订单 ${row.id} 吗?`, '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await cancelOrder(row.id, { reason: '管理员取消' })
          this.$message.success('订单已取消')
          this.fetchData()
        } catch (e) {
          // error handled by interceptor
        }
      }).catch(() => {})
    },
    
    getStatusLabel(status) {
      const map = {
        pending: '待服务',
        serving: '服务中',
        completed: '已服务',
        cancelled: '已取消'
      }
      return map[status] || status
    },
    getStatusType(status) {
      const map = {
        pending: 'warning',
        serving: 'primary',
        completed: 'success',
        cancelled: 'info'
      }
      return map[status] || ''
    },
    getOrderTime(row) {
      return row.order_time || row.created_at || row.create_time || row.order_at || ''
    },
    getServiceTime(row) {
      return row.service_time || row.finished_at || row.complete_time || row.completed_at || ''
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: 100vh;
}
.summary-bar {
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}
.summary-item {
  text-align: center;
}
.summary-item .label {
  color: #909399;
  font-size: 14px;
  margin-bottom: 8px;
}
.summary-item .value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}
.search-bar {
  background-color: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}
.data-table {
  background-color: #fff;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
</style>
